export enum ReportNumberGenerationType {
    LogNumber = 1,
    BookingNumber = 2,
    CaseNumber = 3,
    PropertyTagNumber = 4,
    CitationNumber = 5,
    DomesticViolenceReportNumber = 6,
    UseOfForceReportNumber = 7,
    FieldInterviewNumber = 8,
    CallForServiceNumber = 9,
    NIBRSNumber = 10,
    IncidentNumber = 11,
    ArrestNumber = 12,
    UCRNumber = 13,
    SearchWarrantControlNumber = 14,
    PoliceIncidentNumber = 15,
    DetaineePropertyReceiptNumber = 16,
    PaCriminalComplaintComplaintNumber = 18,
    PaCriminalComplaintAllegationNUmber = 19,
    PropertyAuditNumber = 20,
    ParkingTicketCitationNumber = 21,
    AlarmPermitCommercialNumber = 22,
    AlarmPermitResidentialNumber = 23,
    PropertyItemNumber = 24,
    PaymentReceiptNumber = 25,
    AppearanceTicketNumber = 26
}